import React from "react";
import { DataPointCard } from "../DataPointCard";
import "react-base-table/styles.css";
import useCashOutOverview from "./CashOutOverviewHooks";
import styles from "./CashOutOverview.module.scss";
import { CashOutList } from "./";
import { TABLE_COLUMNS } from "../../pages/OrderCashOut/constants";
import { Menu, MenuItem } from "@blueprintjs/core";
import { useHistory } from "react-router-dom";

const CashOutOverview = ({
  isLoading,
  loadingMore,
  sort,
  onSortPress,
  getColumnWidth,
  amountDue,
  bank,
  payments,
  columnWidths
}) => {
  const history = useHistory();
  return (
    <>
      <div className={styles.reportingOverviewContainer}>
        <div className={styles.dataPointCardsContainer}>
          <DataPointCard
            color="#FF5D78"
            iconName="Cash-Out"
            title="Available to Cash Out"
            value={`$${amountDue.toFixed(2)}`}
          />
          <DataPointCard
            color="#00998c"
            iconName="Bank"
            title={bank.name ? bank.name : "No bank Added"}
            value={bank.digits ? `●●●●${bank.digits}` : "NA"}
            menu={
              <Menu>
                <MenuItem
                  text={
                    bank.digits ? "Update Bank Account" : "Add Bank Account"
                  }
                  onClick={() => {
                    history.push("/settings/bank-account");
                  }}
                />
              </Menu>
            }
          />
        </div>
      </div>
      <div className={styles.secondaryTitle}>
        <h2>Transactions</h2>
      </div>
      <div className={styles.cashoutList}>
        <CashOutList
          loadingMore={loadingMore}
          isLoading={isLoading}
          columns={TABLE_COLUMNS}
          sort={sort}
          getColumnWidth={getColumnWidth}
          onSortPress={onSortPress}
          payments={payments}
          columnWidths={columnWidths}
        />
      </div>
    </>
  );
};

export default CashOutOverview;
